import React from 'react';
import { Link } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';
import Avatar from 'components/common/Avatar';

import HabilitationService from 'services/habilitationsService';

import Logout from 'components/authentication/Logout';
import Login from 'components/authentication/Login';

const ProfileDropdown = () => {

  if(HabilitationService && HabilitationService.habilitations)
  {
    return (
      <Dropdown navbar={true} as="li">
        <Dropdown.Toggle
          bsPrefix="toggle"
          as={Link}
          to="#!"
          className="pe-0 ps-2 nav-link"
        >
          <Avatar
            size="l" 
            name={HabilitationService.habilitations.prenomClient + " " + HabilitationService.habilitations.nomClient}
          />
        </Dropdown.Toggle>

        <Dropdown.Menu className="dropdown-menu-card  dropdown-menu-end">
          <Logout />
        </Dropdown.Menu>
      </Dropdown>
    );
  }else{
    return(<>
      <Login/>
    </>)
  }
  
};

export default ProfileDropdown;
